import React, { useState, useContext } from "react"
import * as styles from "./Styles/ImageList.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import { PlaceImage } from "../types/place"

import ImageModal from "../Common/ImageModal"
import { PCViewContext } from "../Common/PCViewContext"

const PICTURE_LIMIT_INDEX = 3

const Image = (props) => {
  return (
    <div className={cn(props.classes)}>
      <a
        href="#"
        onClick={(e) => {
          props.onClick(e, props.image)
        }}
      >
        <img src={props.image.url} />
      </a>
    </div>
  )
}

const FirstImage = (props) => {
  return <Image {...props} classes={["image", "first"]} />
}

const SecondImage = (props) => {
  return <Image {...props} classes={["image", "second"]} />
}

const ThirdImage = (props) => {
  return <Image {...props} classes={["image", "third"]} />
}

const ImageList = (props) => {
  const images: Array<PlaceImage> = props.images
  const single = images.length == 1
  const couple = images.length == 2
  const multiple = images.length > 2
  const haveMore = images.length > PICTURE_LIMIT_INDEX
  const [selectedImage, setSelectedImage] = useState(null)
  const onImageClick = (e, image) => {
    e.preventDefault()
    setSelectedImage(image)
  }

  return (
    <React.Fragment>
      <div
        className={cn(
          "imageContainer",
          couple ? "imageContainer--couple" : "",
          multiple ? "imageContainer--multiple" : ""
        )}
      >
        {single && <FirstImage image={images[0]} onClick={onImageClick} />}
        {couple && (
          <React.Fragment>
            <FirstImage image={images[0]} onClick={onImageClick} />
            <SecondImage image={images[1]} onClick={onImageClick} />
          </React.Fragment>
        )}
        {multiple && (
          <React.Fragment>
            <div className={styles.multipleLeft}>
              <FirstImage image={images[0]} onClick={onImageClick} />
            </div>
            <div className={styles.multipleRight}>
              <SecondImage image={images[1]} onClick={onImageClick} />
              {haveMore && (
                <div className={cn("image", "third", "haveMore")}>
                  <img src={images[2].url} />
                  <a
                    href={`${location.href}/images`}
                    className={styles.haveMoreLink}
                  >
                    <div className={styles.overlay}>もっと見る</div>
                  </a>
                </div>
              )}
              {!haveMore && (
                <ThirdImage image={images[2]} onClick={onImageClick} />
              )}
            </div>
          </React.Fragment>
        )}
      </div>
      <ImageModal
        image={selectedImage}
        show={selectedImage != null}
        onHide={() => {
          setSelectedImage(null)
        }}
      />
    </React.Fragment>
  )
}

const ImageListWrapper = (props) => {
  const isPC = useContext(PCViewContext)
  return (
    <React.Fragment>
      {isPC && (
        <div className={styles.pcContainer}>
          <ImageList {...props} />
        </div>
      )}
      {!isPC && (
        <div className={styles.spContainer}>
          <ImageList {...props} />
        </div>
      )}
    </React.Fragment>
  )
}

export default ImageListWrapper
